"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchesRules = exports.noneResult = exports.hashKey = exports.isInShardRange = exports.Evaluator = void 0;
const rules_1 = require("./rules");
const sharders_1 = require("./sharders");
class Evaluator {
    constructor(sharder) {
        this.sharder = sharder !== null && sharder !== void 0 ? sharder : new sharders_1.MD5Sharder();
    }
    evaluateFlag(flag, subjectKey, subjectAttributes, obfuscated) {
        var _a, _b;
        if (!flag.enabled) {
            return noneResult(flag.key, subjectKey, subjectAttributes);
        }
        const now = new Date();
        for (const allocation of flag.allocations) {
            if (allocation.startAt && now < new Date(allocation.startAt))
                continue;
            if (allocation.endAt && now > new Date(allocation.endAt))
                continue;
            if (matchesRules((_a = allocation === null || allocation === void 0 ? void 0 : allocation.rules) !== null && _a !== void 0 ? _a : [], Object.assign({ id: subjectKey }, subjectAttributes), obfuscated)) {
                for (const split of allocation.splits) {
                    if (split.shards.every((shard) => this.matchesShard(shard, subjectKey, flag.totalShards))) {
                        return {
                            flagKey: flag.key,
                            subjectKey,
                            subjectAttributes,
                            allocationKey: allocation.key,
                            variation: flag.variations[split.variationKey],
                            extraLogging: (_b = split.extraLogging) !== null && _b !== void 0 ? _b : {},
                            doLog: allocation.doLog,
                        };
                    }
                }
            }
        }
        return noneResult(flag.key, subjectKey, subjectAttributes);
    }
    matchesShard(shard, subjectKey, totalShards) {
        const assignedShard = this.sharder.getShard(hashKey(shard.salt, subjectKey), totalShards);
        return shard.ranges.some((range) => isInShardRange(assignedShard, range));
    }
}
exports.Evaluator = Evaluator;
function isInShardRange(shard, range) {
    return range.start <= shard && shard < range.end;
}
exports.isInShardRange = isInShardRange;
function hashKey(salt, subjectKey) {
    return `${salt}-${subjectKey}`;
}
exports.hashKey = hashKey;
function noneResult(flagKey, subjectKey, subjectAttributes) {
    return {
        flagKey,
        subjectKey,
        subjectAttributes,
        allocationKey: null,
        variation: null,
        extraLogging: {},
        doLog: false,
    };
}
exports.noneResult = noneResult;
function matchesRules(rules, subjectAttributes, obfuscated) {
    return !rules.length || rules.some((rule) => (0, rules_1.matchesRule)(rule, subjectAttributes, obfuscated));
}
exports.matchesRules = matchesRules;
//# sourceMappingURL=evaluator.js.map